var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPin = function SvgPin(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.6 7.1c.9-.3 1.9-.4 2.8-.3 1.1.1 2.5 0 3.3-.8l2.1-2.1c.4-.4.4-1 0-1.4-.4-.4-.4-1 0-1.4L12 1c.3-.3.8-.3 1.1 0l6 6c.3.3.3.8 0 1.1l-.1.1c-.4.4-1.1.4-1.5 0-.4-.4-1.1-.4-1.5 0l-2.1 2.1c-.8.8-.9 2.2-.8 3.3.1.9 0 1.9-.3 2.8-.4 1-1.7 1.1-2.4.3l-2.8-2.8-4.2 4.2c-.4.4-1 .4-1.4 0-.4-.4-.4-1 0-1.4l4.2-4.2-2.9-2.9c-.7-.8-.7-2.1.3-2.5z"
  })));
};
export default SvgPin;